"use client";
import { AnimatePresence, motion } from "framer-motion";

interface TeamProgressProps {
  active: number;
  total: number;
}

const pad = (n: number) => (n < 10 ? `0${n}` : `${n}`);

const TeamProgress = ({ active, total }: TeamProgressProps) => {
  return (
    <div className="flex items-end gap-5 select-none">
      {/* Rolling current number */}
      <div className="flex items-end">
        <div className="relative h-16 w-24 overflow-hidden">
          <AnimatePresence mode="wait">
            <motion.span
              key={active}
              initial={{ y: "110%", opacity: 0 }}
              animate={{ y: "0%", opacity: 1 }}
              exit={{ y: "-110%", opacity: 0 }}
              transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
              className="absolute inset-0 flex items-end font-black leading-none tracking-tighter text-7xl"
            >
              {pad(active + 1)}
            </motion.span>
          </AnimatePresence>
        </div>
        <span className="ml-3 pb-1 text-lg font-medium text-muted-foreground">
          /{pad(total)}
        </span>
      </div>

      {/* Per-member ticks — filled = discovered, tall = active */}
      <div className="mb-2 flex items-end gap-1.5">
        {Array.from({ length: total }).map((_, i) => (
          <motion.span
            key={i}
            className="block w-0.75 rounded-full"
            initial={false}
            animate={{
              height: i === active ? 34 : i < active ? 22 : 14,
              backgroundColor:
                i <= active ? "var(--primary)" : "rgba(0,0,0,0.15)",
            }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          />
        ))}
      </div>
    </div>
  );
};

export default TeamProgress;
